<style lang="sass" scoped>
  @import '../../../sass/variables'

  .card
    height: 400px

    .card-header
      h2
        font-size: 1.25rem
        font-weight: 700
        color: $salesflow-font-gray
        line-height: 120%

    .data
      height: 290px
      overflow-y: auto

      .table
        th
          font-size: 0.75rem
          font-weight: 400
          color: $salesflow-font-gray
          line-height: 125%
          border: none
          padding-top: 6px
          padding-bottom: 6px
          background: $salesflow-bg-content

        tr
          background-color: $salesflow-bg-content

        td
          color: $salesflow-font-dark
          font-size: 0.875rem
          font-weight: 600
          vertical-align: middle
          padding-top: 12px
          padding-bottom: 6px

        td.percent
          font-weight: 400
          color: $salesflow-font-gray
          text-align: center

</style>

<template>
  <div
    class="card card-table with-shadow"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div class="card-header">
      <div class="row">
        <div class="col-12 d-flex">
          <h2>{{ __('Taxa de fechamento por usuário') }}</h2>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      :class="{ hovering }"
    >
      <div
        class="loader"
        v-if="loading"
      >
        <h2 class="text-center">
          <i class="fa fa-circle-o-notch fa-spin" />
        </h2>
      </div>
      <FakeData
        :hovering="hovering"
        zoom="0.75"
        cta="SAIBA MAIS"
        href="https://salesflowcrm.movidesk.com/kb/article/406312/fechamento-por-usuario"
        content="Crie negócios e saiba a conversão de cada vendedor."
        v-else-if="fake"
      />
      <DashboardEmptyData v-else-if="empty" />
      <div
        class="data table-responsive"
        :class="{ disabled: loading, fake, hovering, hidden: empty }"
      >
        <table class="table">
          <thead>
            <tr>
              <th class="sticky-top text-center">
                {{ ('Usuário') }}
              </th>
              <th class="sticky-top text-center">
                {{ __('Iniciados') }}
              </th>
              <th class="sticky-top text-center">
                {{ __('Ganhos') }}
              </th>
              <th class="sticky-top text-center">
                {{ __('R$') }}
              </th>
              <th class="sticky-top text-center">
                %
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in data"
              :key="index"
            >
              <td class="align-middle">
                <b>{{ row.user }}</b>
              </td>
              <td class="text-center">
                {{ row.started | number(0) }}
              </td>
              <td class="text-center">
                {{ row.closed | number(0) }}
              </td>
              <td class="text-center">
                {{ row.value | currency(0) }}
              </td>
              <td class="percent">
                {{ row.closed / row.started | percent(0) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  props: ['user', 'range'],
  mixins: [Widget],

  data () {
    return {
      name: 'user.closes',
      loading: true,
      error: false,
      fake: false,
      empty: false,
      hovering: false,
      data: {},
    };
  },

  watch: {
    loading () {
      this.fake = false;
      this.empty = false;

      if (this.data.fake === true) {
        this.useFakeData();
      } else if (this.dataIsEmpty()) {
        this.empty = true;
      }
    },
  },

  methods: {
    dataIsEmpty () {
      return ! this.data.length;
    },

    useFakeData () {
      this.fake = true;

      this.data = [
        {
          user: 'Steve',
          started: 425,
          closed: 52,
          value: '4402',
        },
        {
          user: 'Alan',
          started: 256,
          closed: 11,
          value: '1793',
        },
        {
          user: 'Joe',
          started: 48,
          closed: 2,
          value: '248',
        },
        {
          user: 'Oliver',
          started: 30,
          closed: 1,
          value: '89',
        },
      ];
    },
  },
};
</script>
